import { fetchAuthSession } from 'aws-amplify/auth';

// const API = 'https://tasks.gerardantoun.com/api/rt/task';
// const API = 'http://localhost:3001';
const API = process.env.REACT_APP_SERVER_URL;

const fetchAccessToken = async () => {
    const session = await fetchAuthSession();
    return session.tokens.accessToken.toString();
}


const fetch2 = async (url, body) => {
    /* 
    This function is a wrapper around the fetch API that sends a POST request to the specified URL with the specified body.
    It also checks if the response is ok, and throws an error if it is not.

    Arguments:
    - url: The URL to send the request to
    - body: The body of the request

    Returns:
    - The result of the request
    */
    const accessToken = await fetchAccessToken();

    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${accessToken}`
        },
        body: JSON.stringify(body)
    });

    // Check if response ok
    if (!response.ok) {
        let errorData;
        try {
            errorData = await response.json(); // Try to parse the error response as JSON
            errorData = errorData.error; // Extract the error message
        } catch (error) {
            errorData = await response.text(); // If parsing as JSON fails, try to parse as text
        }
        throw errorData; // Throw the error data as it is
    }

    const data = await response.json();
    return data.result;
}

const addRtProcessAndSockets = async (
    rt_task_id, dt_process_id, io, parentRtProcessId) => {
    const body = {
        "func": "addRtProcessAndSockets",
        "params": {
            "rt_task_id": rt_task_id,
            "dt_process_id": dt_process_id,
            "io": io,
            "parent_rt_process_id": parentRtProcessId
        }
    };

    const response = await fetch2(`${API}/rt/task`, body);
    return response;
}

const instantiateObject = async (classId) => {
    const body = {
        "func": "instantiateObject",
        "params": {
            "class_id": classId
        }
    };

    const response = await fetch2(`${API}/rt/object`, body);
    return response;
}

const instantiateObjectAndAddToRtSocket = async (rt_task_id, rt_socket_id) => {
    const body = {
        "func": "instantiateObjectAndAddToRtSocket",
        "params": {
            "rt_task_id": rt_task_id,
            "rt_socket_id": rt_socket_id
        }
    };

    const response = await fetch2(`${API}/rt/task`, body);
    return response;
}

const finalizeSocket = async (rt_task_id, rt_socket_id) => {
    const body = {
        "func": "finalizeSocket",
        "params": {
            "rt_socket_id": rt_socket_id,
            "rt_task_id": rt_task_id
        }
    };

    const response = await fetch2(`${API}/rt/task`, body);
    return response;
}

const sendStartSignal = async (rt_task_id) => {
    const body = {
        "func": "sendStartSignal",
        "params": {
            "rt_task_id": rt_task_id
        }
    };

    const response = await fetch2(`${API}/rt/task`, body);
    return response;
}

const instantiateRtSocketsToExistingRtProcess = async (rt_task_id, rt_process_id, io) => {
    const body = {
        "func": "instantiateRtSocketsToExistingRtProcess",
        "params": {
            rt_task_id,
            rt_process_id,
            io
        }
    };

    const response = await fetch2(`${API}/rt/task`, body);
    return response;
}

export {
    addRtProcessAndSockets,
    instantiateObject,
    instantiateObjectAndAddToRtSocket,
    finalizeSocket,
    sendStartSignal,
    instantiateRtSocketsToExistingRtProcess
};